
const sideTypes = [

  { id: 'Buy', value: 'Buy' },
  { id: 'Sell', value: 'Sell' },
  { id: 'Sell Short', value: 'Sell Short' }
];

const filterTimePattern = 'HH:mm:ss.SSS';
const filterDatePattern = 'MM/dd/yyyy';

const capacityTypes = [
  { id: 'A', value: 'A' },
  { id: 'P', value: 'P' },
  { id: 'R', value: 'R' }

];

const liquidityTypes = [

  { id: 'A', value: 'Add' },
  { id: 'D', value: 'Add–Sub Dollar' },
  { id: 'R', value: 'Remove' },
  { id: 'H', value: 'Remove-Sub Dollar' },
  { id: 'L', value: 'Routed - Link ATS' },
  { id: 'X', value: 'Routed - External' },
  { id: 'P', value: 'Ping' }

];
const venueTypes = [
  { id: 'ECN', value: 'ECN' },
  { id: 'Link ATS', value: 'Link ATS' },
  { id: 'ARCA', value: 'ARCA' },
  { id: 'CICF', value: 'CICF' },
  { id: 'IDQS', value: 'IDQS' }];

const TRADE_CATEGORY = [8, 6209, 7094, 7168, 7166];

// IDQS
const IDQS_TRADE_CATEGORY = [8, 6209, 7094, 7168, 7167];

const idqsVenueTypes = [
  { id: 8, value: 'ECN' },
  { id: 6209, value: 'Link ATS' },
  { id: 7094, value: 'ARCA' },
  { id: 7168, value: 'CICF' },
  { id: 7167, value: 'OTCX' }];

// NMS

const NMS_TRADE_CATEGORY = [8, 7272, 6209, 7094, 7168, 7167];

const nmsVenueTypes = [
  { id: 8, value: 'MOON' },
  { id: 7272, value: 'Blue Ocean' },
  { id: 6209, value: 'Link ATS' },
  { id: 7094, value: 'ARCA' },
  { id: 7168, value: 'CICF' },
  { id: 7167, value: 'OTCX' }];

export { NMS_TRADE_CATEGORY, IDQS_TRADE_CATEGORY, nmsVenueTypes, idqsVenueTypes, TRADE_CATEGORY, sideTypes, venueTypes, liquidityTypes, capacityTypes, filterDatePattern, filterTimePattern };
